import { Component } from '@angular/core';
import { ManageTipBaseComponent } from '@moduurnv2/libs-orderingapp/src';

@Component({
  selector: 'moduurnv2-manage-tip',
  templateUrl: './manage-tip.component.html',
  styleUrls: ['./manage-tip.component.scss'],
})
export class ManageTipComponent extends ManageTipBaseComponent {}
